<div class="modal-header">
    <h2 class="modal-title">{{ "specialOffers.filterModal.title" | translate }}</h2>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-12 l-title-txt">
            {{ "specialOffers.filterModal.issueDate" | translate }}
        </div>
        <div class="col-md-6 select-date">
            <label class="label-input">
                {{ "specialOffers.filterModal.fromDate" | translate }}
            </label>
            <kendo-datepicker HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [(ngModel)]="startDate"
                [disabledDates]="disableStartDates"
                #startDateInput
                (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}">
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}">
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
        <div class="col-md-6 select-date">
            <label class="label-input">
                {{ "specialOffers.filterModal.toDate" | translate }}
            </label>
            <kendo-datepicker HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [(ngModel)]="endDate"
                [disabledDates]="disableEndDates"
                #endDateInput
                (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}">
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}">
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
    </div>
    <div class="l-separator"></div>
    <div class="row modal-section">
        <div class="col-md-12 l-title-txt">
            {{ "specialOffers.filterModal.Type" | translate }}
        </div>
        <div *ngFor="let type of types"
            class="col-md-6 d-flex align-items-center mb-3">
            <input
                HJSuppress
                type="checkbox"
                kendoCheckBox
                [size]="size"
                [rounded]="roundedLarge"
                [id]="type.id"
                [(ngModel)]="type.isSelected"/>
            <label HJSuppress
                [for]="type.id"
                class="cursor-pointer ms-2">
                {{ type.value }}
            </label>
        </div>
    </div>
    <div class="l-separator"></div>
    <div class="row modal-section">
      <div class="col-md-12 l-title-txt">
        {{ "specialOffers.filterModal.status" | translate }}
      </div>
      <div *ngFor="let status of statuses; index as i"
           class="col-md-6 d-flex align-items-center mb-3">
        <input
          HJSuppress
          type="checkbox"
          kendoCheckBox
          [(ngModel)]="status.isSelected"
          [id]="status.name+i"
          [size]="size"
          [rounded]="roundedLarge"/>
        <label HJSuppress [for]="status.name+i" class="cursor-pointer ms-2 status-badge"
               [ngClass]="status.value.toLowerCase()">
          {{ status.name }}
        </label>
      </div>
    </div>
    <div class="l-separator"></div>
    <div class="row modal-section">
        <div class="col-md-12 l-title-txt">
            {{ "specialOffers.filterModal.dealer" | translate }}
        </div>
        <div *ngFor="let dealer of dealers"
            class="col-md-6 d-flex align-items-center mb-3">
            <input
                HJSuppress
                type="checkbox"
                kendoCheckBox
                [size]="size"
                [rounded]="roundedLarge"
                [id]="dealer.id"
                [(ngModel)]="dealer.isSelected"/>
            <label HJSuppress
                [for]="dealer.id"
                class="cursor-pointer ms-2">
                    {{ dealer.value }}
            </label>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i>
        {{ "specialOffers.filterModal.reset" | translate }}
    </button>
    <button class="btn primary-btn" (click)="applyHandler()">
        {{ "specialOffers.filterModal.apply" | translate }}
    </button>
</div>
